import React from 'react';
import { Route } from 'react-router-dom';

export const RouteWithLayout = (props: {
  component: any,
  layout: any,
  path?: string
  exact?: boolean
}) => {
  const { layout: Layout, component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

export default RouteWithLayout;
